import React from "react";
import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import PreviewForm from "./previewForm";
import EditForm from "./editForm";

const FormCard = ({
  t,
  lng,
  edit,
  fields,
  values = {},
  updateEntityInfo,
  FIELDS_WITHOUT_QUOTES,
  errors = {},
}) => {
  if (!fields) return null;
  if (edit)
    return (
      <EditForm
        t={t}
        fields={fields.edit}
        values={values}
        lng={lng}
        updateEntityInfo={updateEntityInfo}
        FIELDS_WITHOUT_QUOTES={FIELDS_WITHOUT_QUOTES}
        errors={errors}
      />
    );

  return <PreviewForm t={t} fields={fields.previewForm} values={values} />;
};

export default withNamespaces()(withRouter(FormCard));
